module.exports = __webpack_public_path__ + "static/media/nicholaspsmith1.61bd024c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/nicholaspsmith1.png
// module id = 264
// module chunks = 0